import { lowerCase } from 'lodash-es';
import React, { PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';
import { useLocale, useT } from '@transifex/react';
import { useTheme } from 'styled-components';
import en from 'antd/lib/locale/en_US';
import { Locale } from 'antd/es/locale';
import enGB from 'antd/es/locale/en_GB';
import daDK from 'antd/es/locale/da_DK';
import { TLocales } from '../transifex';
import { buildAntdConfigTheme } from './antdTheme';
import { useIsTenantDark } from './Company.store';

const AntdI18n: React.FC<PropsWithChildren> = ({ children }) => {
  const locale = useLocale();
  const theme = useTheme();
  const isDark = useIsTenantDark();

  const t = useT();

  const txOptional = `(${lowerCase(t('optional'))})`;

  const antdLocaleMap: Record<TLocales, Locale> = {
    en: enGB,
    da: {
      ...daDK,
      Form: {
        ...daDK.Form,
        optional: txOptional,
        defaultValidateMessages: {
          ...daDK.Form?.defaultValidateMessages,
        },
      },
    },
  };

  return (
    <ConfigProvider
      locale={antdLocaleMap[locale as TLocales] || en}
      theme={buildAntdConfigTheme(theme, isDark)}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdI18n;
